import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { LoginService } from 'src/app/services/login.service';
import { ShareService } from 'src/app/services/share.service';

@Component({
  selector: 'app-qr-afiliado',
  templateUrl: './qr-afiliado.component.html',
  styleUrls: ['./qr-afiliado.component.scss'],
})
export class QrAfiliadoComponent implements OnInit {
  @Input() uri: string = '';
  @Input() title: string = '';
  @Input() type: 'qr' | 'link' = 'qr';
  public value = '';

  constructor(
    private shareSv: ShareService,
    private loginSv: LoginService,
    private modalController: ModalController
  ) {}

  async ngOnInit() {
    this.value = await this.shareSv.share(
      '',
      `&code=${this.loginSv.user.code}`,
      this.uri,
      true
    );
  }

  async close() {
    await this.modalController.dismiss();
  }

  async copy() {
    await this.shareSv.share('', `&code=${this.loginSv.user.code}`, this.uri);
  }

  downloadQr() {
    const fileNameToDownload = 'image_qrcode';
    const base64Img =
      document.getElementsByClassName('aclass')[0].children[0]['src'];
    fetch(base64Img)
      .then((res) => res.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileNameToDownload;
        link.click();
      });
  }
}
